import { useEffect } from 'react';
import './App.css';
import VMProvider from './components/VMProvider'
import store from './store';
import DirStudio from './views/DirStudio/DirStudio';
import { Provider as StoreProvider } from 'react-redux'

// Moving between the load screen and a movie is a real document navigation,
// precisely so each one gets a new VM (see onPlayDemo in LoadMovie). The
// back/forward cache would undo that: it revives the frozen document, VM
// instance and all, instead of loading it again — so Back out of a movie could
// hand you the load screen with the previous game's player still behind it.
// Restoring from bfcache is the one case where we have to insist on a reload.
//
// This lives here rather than in VMProvider because the polyfill and extension
// mount VMProvider inside somebody else's page, where reloading the document is
// not ours to do.
function useReloadOnBackForwardCacheRestore() {
  useEffect(() => {
    const onPageShow = (event: PageTransitionEvent) => {
      if (event.persisted) window.location.reload();
    };
    window.addEventListener('pageshow', onPageShow);
    return () => window.removeEventListener('pageshow', onPageShow);
  }, []);
}

function App() {
  useReloadOnBackForwardCacheRestore();
  return (
    <div className="App">
      <StoreProvider store={store}>
        <VMProvider>
          <DirStudio />
        </VMProvider>
      </StoreProvider>
    </div>
  );
}

export default App;
